import React from "react";
import { Button } from "@origin-digital/ods-core";
import { useCloseTransferFormProps } from "./useCloseTransferFormProps";
import { formCloseTransferValidationSchema } from "../../FormComponents/Validations";
import { ValidationError } from "yup";
import { yupToFormErrors } from "formik";
import { usePermissions } from "src/hooks/usePermissions";

export const CloseTransferFormLegacyActionSection: React.FC<{
  submitCloseTransfer: () => Promise<void>;
}> = ({ submitCloseTransfer }) => {
  const {
    formikContext: { values, setErrors },
    formBehavior: {
      isElectricityEnable,
      isGasEnable,
      isGasReadOnly,
      isElectricityReadOnly,
      accountPayers,
    },
  } = useCloseTransferFormProps();
  const { hasViewAllRequestsPermissions } = usePermissions();
  const { handoverType, isShowCustomerConsentCheckbox } = values.closeTransfer;

  const submitForm = () => {
    formCloseTransferValidationSchema()
      .validate(values, {
        context: {
          isGasReadOnly,
          isElectricityReadOnly,
          handoverType,
          accountPayers,
          isShowCustomerConsentCheckbox,
          isElectricityEnable,
          isGasEnable,
        },
        abortEarly: false,
      })
      .then(async () => {
        await submitCloseTransfer();
      })
      .catch((error: ValidationError) => {
        setErrors(yupToFormErrors(error));
      });
  };

  const shouldRender =
    (isElectricityEnable || isGasEnable) && !hasViewAllRequestsPermissions;

  if (shouldRender) {
    return (
      <Button
        onClick={() => {
          submitForm();
        }}
      >
        Lodge
      </Button>
    );
  } else {
    return null;
  }
};
